import { FormField } from 'taboola-ultimate-ui';
import { useNavigate } from 'hooks';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useModal } from 'modules/taboola-common-frontend-modules/modals';
import { TrackingCodelessConversionSetupMethodModal } from '../components/TrackingSetupMethodModal/TrackingCodelessConversionSetupMethodModal';
import { ENTITY } from '../config';
import { generateConversionCodelessCreatorPath, generateConversionCreatorPath } from '../utils/generateTrackingPath';
import styles from './useTrackingSetupMethodTypeModal.module.scss';

const paths = {
    [ENTITY.CODELESS_EVENT_TOOL]: generateConversionCodelessCreatorPath(),
    [ENTITY.CONVERSION]: generateConversionCreatorPath(),
};
export const useTrackingSetupConversionTypeModal = openInNewTab => {
    const navigate = useNavigate();

    const { open: openModal } = useModal();

    const openTrackingSetupModal = async () => {
        const trackingSetupMethodType = await openModal({
            title: (
                <FormField
                    label={
                        <FormattedMessage
                            id="app.modal.tracking.conversion.setup.title"
                            defaultMessage="New conversion"
                        />
                    }
                    description={
                        <FormattedMessage
                            id="app.modal.tracking.conversion.setup.description"
                            defaultMessage="Choose a tracking method from the options below to start measuring the impact of your Realize."
                        />
                    }
                    labelClass={styles['modal']}
                />
            ),
            contentRenderer: TrackingCodelessConversionSetupMethodModal,
            className: styles['modal'],
        });

        if (!trackingSetupMethodType) {
            return;
        }

        if (openInNewTab) {
            const win = window.open(paths[trackingSetupMethodType], '_blank');
            win.focus();
            return;
        }

        navigate(paths[trackingSetupMethodType]);
    };

    return { openTrackingSetupModal };
};
